import React, { useState } from 'react'
import './styles/EditPreference.css'
import CloseIcon from '@mui/icons-material/Close';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import FavoriteOutlinedIcon from '@mui/icons-material/FavoriteOutlined';
import SentimentVerySatisfiedOutlinedIcon from '@mui/icons-material/SentimentVerySatisfiedOutlined';
import { Oval } from 'react-loader-spinner';
import { useModal } from '../contexts/ModalContext';

const vibeOptions = [
    { id: 'serious', label: 'Serious Athlete', icon: <EmojiEventsOutlinedIcon sx={{ fontSize: '24px' }} />, description: 'Focused on performance and results' },
    { id: 'balanced', label: 'Somewhere in Between', icon: <FavoriteOutlinedIcon sx={{ fontSize: '24px' }} />, description: 'Mix of fun and fitness goals' },
    { id: 'fun', label: 'Just Here for Fun', icon: <SentimentVerySatisfiedOutlinedIcon sx={{ fontSize: '24px' }} />, description: 'All about enjoying the journey' },
];

export default function EditPreference({ handleClose, type, currentValue, onSave, exerciseTypes = [] }) {
    const { openModal } = useModal();
    const [selected, setSelected] = useState(currentValue || '');
    const [loading, setLoading] = useState(false);

    const title = type === 'vibe' ? 'My Vibe' : 'Favourite Exercise';

    const handleConfirm = async () => {
        if (!selected) return;
        setLoading(true);
        const res = await onSave(selected);
        setLoading(false);
        if (res?.success) {
            handleClose();
        } else {
            openModal('alert', { alertProps: { type: 0, message: 'Request error, please try again.' } });
        }
    };

    return (
        <div className='pref-backdrop' onClick={handleClose}>
            <div className='edit-pref-body' onClick={e => e.stopPropagation()}>
                <div className='edit-pref-header'>
                    <h3 className='edit-pref-title'>{title}</h3>
                    <button className='edit-pref-close' onClick={handleClose}>
                        <CloseIcon sx={{ fontSize: '20px' }} />
                    </button>
                </div>

                <div className='edit-pref-options'>
                    {type === 'vibe' ? (
                        vibeOptions.map(opt => (
                            <button
                                key={opt.id}
                                className={`pref-option${selected === opt.id ? ' selected' : ''}`}
                                onClick={() => setSelected(opt.id)}
                            >
                                <span className='pref-option-icon'>{opt.icon}</span>
                                <div>
                                    <div className='pref-option-label'>{opt.label}</div>
                                    <div className='pref-option-desc'>{opt.description}</div>
                                </div>
                            </button>
                        ))
                    ) : (
                        exerciseTypes.map(et => (
                            <button
                                key={et.id}
                                className={`pref-option${selected === et.id ? ' selected' : ''}`}
                                onClick={() => setSelected(et.id)}
                            >
                                <div className='pref-option-label'>{et.name || et.id}</div>
                            </button>
                        ))
                    )}
                </div>

                <div className='edit-pref-footer'>
                    <button className='edit-pref-confirm' onClick={handleConfirm} disabled={!selected || loading}>
                        {loading
                            ? <Oval visible={true} height="20px" width="20px" color="#ffffff" strokeWidth={4} ariaLabel="oval-loading" wrapperStyle={{ margin: '0' }} wrapperClass="" />
                            : 'Save'
                        }
                    </button>
                </div>
            </div>
        </div>
    );
}
